/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Removed_FolderInputs */

const en_toast_removed_folder = /** @type {(inputs: Toast_Removed_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Removed folder`)
};

const es_toast_removed_folder = /** @type {(inputs: Toast_Removed_FolderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta eliminada`)
};

/**
* | output |
* | --- |
* | "Removed folder" |
*
* @param {Toast_Removed_FolderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_removed_folder = /** @type {((inputs?: Toast_Removed_FolderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Removed_FolderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_removed_folder(inputs)
	return en_toast_removed_folder(inputs)
});